module.exports = __webpack_public_path__ + "img/home10.f698aa72.png";